'use strict';

var React = require('react');
var moment = require('moment');
require('moment/locale/de');

class CalendarControls extends React.Component {
  _onNext = () => {
    this.props.onNext();
  }

  _onPrev = () => {
    this.props.onPrev();
  }

  render() {
    moment.locale('de');

    return (
      <div className='clndr-controls'>
        <div className="arrows" onClick={this._onPrev}><i className="fa fa-angle-left"></i></div>
        <div className='current-month'>{this.props.date.format('MMMM YYYY')}</div>
        <div className="arrows" onClick={this._onNext}><i className="fa fa-angle-right"></i></div>
      </div>
    );
  }
}

module.exports = CalendarControls;



// WEBPACK FOOTER //
// ./src/components/CalendarControls.js